import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.PricingDistributionTemplate.List.IRequest;
type Response = Api.Core.PricingDistributionTemplate.List.IResponse;
type Headers = Api.Core.PricingDistributionTemplate.List.IHeaders;
const url = '/api/ProductManagement/PricingDistributionTemplate';
export default async function pricingDistributionTemplateListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
